<main class="h-svh w-full bg-secondary inline-flex">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>
  <!-- Content for MainLayout -->
  <section class="min-w-0 flex-1 flex flex-col overflow-hidden">
    <!-- Header for MainLayout -->
    <nav class="w-full flex justify-between items-center bg-black text-white px-6 py-4 h-16">
     <div class="flex items-center gap-4">
       <!-- Hamburger: mobile only -->
       <button
         (click)="openMobileSidebar()"
         class="lg:hidden shrink-0 p-1.5 rounded-md text-muted-foreground hover:bg-accent cursor-pointer mr-2"
         aria-label="Ouvrir le menu"
       >
         <app-icon name="menu" [size]="20" aria-hidden="true" />
       </button>
       <div class="flex items-end gap-2">
         <h1 class="text-xl font-bold">CREDIT ACCESS</h1>
         <span class="text-xs">{{ version }}</span>
       </div>
     </div>

      <!-- Search area: keep the results dropdown positioned relative to this container -->
      <div class="flex items-center gap-2 ml-auto">
        <!-- Thème clair / sombre -->
        <app-theme-toggle />

        <!-- Notifications -->
        <app-notification />

        <!-- User menu -->
        <app-dropdown [items]="menuItems" align="end" ariaLabel="Options utilisateur">
          <button
            dropdownTrigger
            class="flex items-center gap-2 p-2 h-10 hover:bg-accent/10 cursor-pointer pl-4 rounded-md"
          >
            <div class="text-right">
              <p class="text-sm font-semibold">{{ user()?.nom }} {{ user()?.prenom }}</p>
              <p class="text-xs">{{user()?.profil?.libelle ?? "-"}}</p>
            </div>
            <app-avatar size="sm" />
          </button>
        </app-dropdown>
      </div>


    </nav>

    <!-- Zone contenu + loader (hors scroll) -->
    <div class="relative flex-1 overflow-hidden">
      <section class="w-full h-full p-6 overflow-y-auto overflow-x-hidden">
        <app-breadcrumb [items]="breadcrumbItems" />
        <router-outlet></router-outlet>
      </section>
      <app-route-loader></app-route-loader>
      <app-lightbox
        [images]="lightbox.images()"
        [open]="lightbox.isOpen()"
        [startIndex]="lightbox.startIndex()"
        (openChange)="lightbox.setOpen($event)"
      />
    </div>
  </section>
</main>
